<template>
  <div class="container-fluid full-page">
    <div class="row">
      <div class="header col-12 justify-content-center">
        <h1 class="title display-2">{{$t('title')}}</h1>
      </div>

      <div class="col-12 justify-content-center">
        <h3 id="subtitle">{{$t('message')}}</h3>
        <i18n tag="p" path="backlink">
          <router-link to="/">{{$t('homepage')}}</router-link>
        </i18n>
      </div>
    </div>
  </div>
</template>

<i18n>
en:
  title: Page not found.
  message: This is a 404 error. We're sorry.
  backlink: Back to the {0}
  homepage: Home page
de:
  title: Seite nicht gefunden.
  message: Dies ist ein 404-Fehler. Das hätte nicht passieren sollen.
  backlink: Zurück zur {0}
  homepage: Startseite
</i18n>

<script>
export default {
  name: 'NotFound',
  data() {
    return {

    };
  },
};
</script>

<style scoped>
.row {
  text-align: center;
}

h1.title {
  text-transform: uppercase;
  text-align: center;
  margin-top: 150px;
  user-select: none;
}

.header {
  margin-top: 50px;
  margin-bottom: 10px;
  padding-left: 50px;
  padding-right: 50px;
}

#subtitle {
  color: #000;
  margin-bottom: 150px;
  font-weight: 100;
  user-select: none;
}

@media (max-width: 567.99px) {
  h1.title {
    font-size: 2.5rem;
    font-weight: normal;
    margin-top: 100px;
  }

  #subtitle {
    font-size: 1.2rem;
    margin-bottom: 50px;
  }
}

@media (max-width: 375.99px) {
  h1.title {
    font-size: 2rem;
    font-weight: lighter;
    margin-top: 0px;
  }

  #subtitle {
    font-size: 1rem;
    margin-bottom: 10px;
  }
}

#bg {
  background-color: #ffc107;
}

</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue